import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'

// Hooks
import { useTrigger } from '../../../../hooks'

// Components
import UIButton from '../../../UI/Button'
import UIForm from '../../../UI/FormReload'
import UIFormInputSelect from '../../../UI/FormReload/Input/Select'
import UIFormInputNumber from '../../../UI/FormReload/Input/Number'
import UIFormInputText from '../../../UI/FormReload/Input/Text'
import UIFormSeparation from '../../../UI/FormReload/Separation'
import UIPanelInfoTable from '../../../UI/Panel/Info/Table'

// // Queries
// import {
//   READ_BRANDS,
//   CREATE_BRANDS,
//   UPDATE_BRANDS,
//   LIST_BRANDS,
// } from './queries'
//
// const queries = {
//   read: READ_BRANDS,
//   create: CREATE_BRANDS,
//   update: UPDATE_BRANDS,
//   list: LIST_BRANDS,
// }

const AdministrationFormStorehouse = () => {
  const [triggerReset, setTriggerReset] = useTrigger()

  // --------------------------------------------------------------------------
  //
  // Render
  //
  // --------------------------------------------------------------------------

  const handleSubmit = (values) => {
    //    onFilterChange(values)
    setTriggerReset()
  }

  return (
    <Row className="m-4">
      <Col className="mb-3">
        <UIForm onSubmit={handleSubmit} triggerReset={triggerReset}>
          <Form.Group as={Row} className="my-1">
            <Col className="d-flex">
              <UIButton type="submit">Ingresar</UIButton>
            </Col>
          </Form.Group>
          <Row>
            <Col xs={12}>
              <UIFormSeparation text="Bodegaje" />
              <UIPanelInfoTable>
                {[
                  [
                    'Tipo Lubricante',
                    <UIFormInputSelect name="id_lubricant_type">
                      <option value={1}>Aceite</option>
                      <option value={2}>Grasa</option>
                    </UIFormInputSelect>,
                  ],
                  [
                    'Nombre Lubricante',
                    <UIFormInputSelect name="id_lubricant">
                      <option value={1}>Aceite A</option>
                      <option value={2}>Aceite B</option>
                    </UIFormInputSelect>,
                  ],
                  ['Cantidad', <UIFormInputNumber name="amount" required />],
                  [
                    'Unidad de medida',
                    <UIFormInputSelect name="id_unit">
                      <option value={1}>Litros</option>
                      <option value={2}>Galones</option>
                    </UIFormInputSelect>,
                  ],
                  [
                    'Acción',
                    <UIFormInputSelect name="id_unit">
                      <option value={1}>Ingreso</option>
                      <option value={2}>Salida</option>
                    </UIFormInputSelect>,
                  ],
                ]}
              </UIPanelInfoTable>
            </Col>
          </Row>
        </UIForm>
      </Col>
    </Row>
  )
}

export default AdministrationFormStorehouse
